
import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["preview"]

  connect() {
        
  }

  togglePreview() {
    console.log("preview")
    this.previewTarget.classList.toggle("pointer-events-none");
    this.previewTarget.classList.toggle("tooltip")
    this.element.classList.toggle("has-tooltip")
  }

}
